import * as React from 'react';
import { PaymentBrand, PaymentMethodLogo } from '@wix/billing-client-common';
import s from './PageFooter.scss';
import { CardBrands } from 'src/constants';

interface AcceptedPaymentMethodIconsProps {
  paymentMethods: CardBrands[];
}

export const AcceptedPaymentMethodIcons: React.FC<AcceptedPaymentMethodIconsProps> = ({
  paymentMethods,
}) => {
  return (
    <React.Fragment>
      {paymentMethods.map((paymentMethod: CardBrands) => (
        <span
          key={paymentMethod}
          data-hook={paymentMethod}
          className={s.acceptedPaymentMethodIcon}
        >
          <PaymentMethodLogo
            cardBrand={(paymentMethod as unknown) as PaymentBrand}
            className={s.paymentMethodLogo}
          />
        </span>
      ))}
    </React.Fragment>
  );
};
